import {DateTime} from './time';

class Hours extends DateTime {
  constructor(o) {
    super(o);
    this.resetModel = ['year', 'month', 'date', 'hours'];
  }

  addVirtual() {
    const li = this.initTimes();
    const time = {
      h: 'div', c: 'time-picker',
      z: [
        {
          h: 'div', c: 'action-header',
          z: [
            {
              h: 'div',
              c: 'action-item-content',
              html: `${this.value.year}年 ${this.value.month}月 ${this.value.date}日`,
              event: (ev) => {
                ev.stopPropagation();
              }
            }
          ]
        },
        {
          h: 'div', c: 'action-mian flex',
          z: [
            {
              h: 'ul', c: 'time-list', id: 'hfs-date-picker-hours', z: li.h
            }
          ]
        }
      ]
    };
    this.virtual.push(time);
  }
}

export {Hours};